// third-party
import { combineReducers } from 'redux';

// project-imports
import menu from './menu';
import snackbar from './snackbar';
import cartReducer from './cart';
import sessionReducer from './session.reducers';
import uploadReducer from './upload.reducers';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  snackbar,
  cart: cartReducer,
  sessionReducer,
  uploadReducer
});

export default reducers;
